import { CerFormView } from '@cer/cer-form/cer-form-view';
import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';

/*export const onlySalesCmd: UiCommand = {
  id: 'onlySalesCmd',
  text: 'Vis alle',
  align: 'Right',
  iconCss: "e-menu-icon e-icons e-circle-check",
  tooltipText: 'Vis kun salg',
  target: ".e-content"
};*/

export class WarehouseOutboundConfirmTransForm extends CerFormAdapter {

  override view(): CerFormView {

    return new CerFormView({

      toolbarCommands: [/*onlySalesCmd*/],
      viewMetadata: {
        dataApiName: 'WarehouseOutboundOrderConfirm', 
        primaryKey: 'pickOrderNum', allowEdit: false, allowCreate: false, allowDelete: false
      },
      fieldMetadata: [
        { name: 'orderCreated', text: 'Ordre oprettet', format: 'DateShort', orderBy: 'Descending', orderByPriority: 1 },
        { name: 'outboundOrderNum', text: 'Forsendelse', foreignKeyType: 'warehouseOutboundOrderLookup', widthType: FieldWidthEnum.XS, orderBy: 'Descending', orderByPriority: 2 },
        { name: 'warehouseCounterpart', text: 'Kundenr.', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'pickOrderNum', text: 'Lagerordre', widthType: FieldWidthEnum.S, visible: false },
        { name: 'customerRef', text: 'Kunderef.', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'orderReference', text: 'Reference', widthType: FieldWidthEnum.XS },
        { name: 'orderStatus', text: 'Status', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'product', fieldType: 'productLookup' },
        { name: 'productName', text: 'Titel', widthType: FieldWidthEnum.XL, foreignKeyUsing: 'product' },
        { name: 'orderedQty', text: 'Lagerantal', format: 'Integer', visible: false },
        { name: 'salesQty', text: 'Antal', format: 'Integer' },
        { name: 'nameDlv', text: 'Navn', widthType: FieldWidthEnum.M },
        { name: 'streetDlv', text: 'Adresse', widthType: FieldWidthEnum.M },
        { name: 'zipCodeDlv', text: 'Postnr', widthType: FieldWidthEnum.XS },
        { name: 'cityDlv', text: 'Bynavn', widthType: FieldWidthEnum.XS },
        { name: 'countryRegionIdDlv', text: 'Land', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'email', text: 'Email', format: 'Email', widthType: FieldWidthEnum.S, visible: false },
        { name: 'phone', text: 'Telefon', format: 'Phone', widthType: FieldWidthEnum.S, visible: false },
        { name: 'carrierCode', text: 'Transportør', widthType: FieldWidthEnum.XXS, visible: false },
        { name: 'carrierServiceCode', text: 'Transportør service', widthType: FieldWidthEnum.XXS, visible: false },
        { name: 'deliveryHandlingType', text: 'Ordretype', widthType: FieldWidthEnum.XXS },
        { name: 'currencyCode', text: 'Valuta', widthType: FieldWidthEnum.XXS, visible: false },
        { name: 'customerLineNum', text: 'Linje', format: 'Number', visible: false },
        { name: 'salesUnit', text: 'Enhed', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'salesPrice', text: 'Listepris', format: 'Amount0', visible: false },
        { name: 'discAmount', text: 'Rabat', format: 'Amount0', visible: false },
        { name: 'discPercent', text: 'Rabat%', format: 'AmountPct0', visible: false },
        { name: 'lineAmount', text: 'Linjebeløb', format: 'Amount0', visible: false },
        { name: 'inventLocationId', text: 'Lagersted', visible: false },
        { name: 'lineStatus', text: 'Status' },
        { name: 'created', text: 'Oprettet', tooltipText: 'Oprettet dato', allowEdit: false, format: 'DateLong', visible: false },
        { name: 'modified', text: 'Ændret', tooltipText: 'Ændret dato', allowEdit: false, format: 'DateLong', visible: false },
        { name: 'createdJobId', text: 'Oprettet job', format: 'Number', visible: false },
        { name: 'modifiedJobId', text: 'Ændret job', format: 'Number', visible: false }
      ]
    });
  }
}
